import { createGlobalStyle } from 'styled-components';

export const SIZE = {
  sm: 576
};

export const DEVICE = {
  mobile: `(max-width: ${SIZE.sm - 0.02}px)`,
  desktop: `(min-width: ${SIZE}px)`
};

export default createGlobalStyle`
  /* BLOCO BÁSICO PARA CONSTRUÇÃO DA APP */
  sdiv {
    animation: 0s none;
    backface-visibility: visible;
    background: none;
    border: 0;
    box-shadow: none;
    box-sizing: border-box;
    bottom: auto;
    caption-side: top;
    clear: none;
    clip: auto;
    cursor: inherit;
    display: block;
    direction: ltr;
    flex: none;
    height: auto;
    hyphens: manual;
    image-rendering: auto;
    justify-content: flex-start;
    left: auto;
    letter-spacing: normal;
    line-height: normal;
    margin: 0;
    max-height: none;
    max-width: none;
    min-height: 0;
    min-width: 0;
    object-fit: fill;
    opacity: 1;
    order: 1;
    orphans: 2;
    outline: 0 none;
    overflow: visible;
    padding: 0;
    perspective: none;
    position: static;
    resize: none;
    right: auto;
    text-align: left;
    text-decoration: none;
    text-indent: 0;
    text-overflow: clip;
    text-shadow: none;
    text-transform: none;
    top: auto;
    transform: none;
    transition: all 0s ease 0s;
    unicode-bidi: normal;
    user-select: none;
    vertical-align: baseline;
    white-space: normal;
    width: auto;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    z-index: auto;
    zoom: normal;
    filter: none !important;
    font-weight: 400;
    font-family: 'Roboto', sans-serif;
  }

  .wppMediaLoading {
    animation: mediaLoading 2s linear infinite;
    z-index: 2;
    display: block;
    pointer-events: none;
    margin: -2px 0 0 -2px;
  }

  @keyframes mediaLoading {
    to {
      transform: rotate(1turn)
    }
  }

  .wppMessageLoading {
    animation: mediaLoading 1.6s linear infinite;
    z-index: 2;
    flex: 1;
    pointer-events: none;
    width: 24px;
    height: 24px;
    text-align: center;
    align-self: center;
    /* border: solid 1px red; */
  }

  .wppMediaLoadingCircle {
    stroke: rgba(255, 255, 255);
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: mediaLoadingCircle 1.5s ease-in-out infinite;
  }

  .wppMessageLoadingCircle {
    stroke: #429789;
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: mediaLoadingCircle 1.5s ease-in-out infinite;
  }

  @keyframes mediaLoadingCircle {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35
    }
    to {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124
    }
  }

  /* RECORDING AUDIO */

  @keyframes recording {
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }

  @keyframes width-increase {
    0% {
      width: 180px;
      opacity: 0;
    }
    100% {
      width: 220px;
      opacity: 1;
    }
  }

  @keyframes width-decrease {
    0% {
      width: 220px;
    }
    100% {
      width: 44px;
    }
  }

  /* PLACEHOLDER LOADING */

  & .uiPlaceholderInline {
    display: inline-block;
    width: 75px;
    margin-right: 10px;
    height: 12px;
    background-color: rgba(110, 110, 110, 0.5);
    border-radius: 2px;
    animation: placeholder-inline 2s ease-in-out infinite;
  }

  @keyframes placeholder-inline {
    0% {
      background-color: rgba(134, 134, 134, 0.1);
    }
    100% {
      background-color: rgba(134, 134, 134, 0.4);
    }
  }

  & .MuiTooltip-popper {
    z-index: 10001 !important;
  }

  /*
    #⚛️ *:not([class^="MuiInput"]) {
      box-sizing: border-box;
    }

    #⚛️ *:not(span){
      font-family: 'Roboto', sans-serif;
    }
  */

  #⚛️ input[type=range] {
    appearance: none;
    /* Hides the slider so that custom slider can be made */
    width: 100%;
    /* Specific width is required for Firefox. */
  }

  #⚛️ input[type=range]::-webkit-slider-thumb {
    appearance: none;
    height: 14px;
    width: 14px;
    border-radius: 50%;
    /* background: #00a5f4; */
    cursor: default;
    margin-top: -6px;
  }

  #⚛️ input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 3px;
    cursor: pointer;
  }

  & .public-DraftEditor-content {
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
  }

  & .public-DraftEditorPlaceholder-root {
    color: #999;
    pointer-events: none;
    font-size: 13px;
    font-family: 'Roboto', sans-serif;
    position: absolute;
    transition: opacity .08s linear;
    user-select: none;
  }
  
  #⚛️ ::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
  }

  #⚛️ ::-webkit-scrollbar-track {
    background: hsla(0, 0%, 100%, .1);
  }

  #⚛️ ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, .2);
  }

  & .emoji-mart {
    background-color: #F0F0F0;
    border: unset !important;
    width: 100% !important;
  }

  & .emoji-mart-category-label span { 
    background-color: #F0F0F0;
  }

  & .emoji-mart-search input {
    background-color: #D9D9D9;
  }

  & .emoji-mart-anchor-bar {
    background-color: #429789 !important;
  }

  & .emoji-mart-anchor-icon svg {
    color: #858585;
  }

  & .emoji-mart-category {
    margin-top: 15px;
  }

  & .emoji-mart-category div span {
    color: rgba(0, 0, 0, .45);
  }

  & .emoji-mart-scroll {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 164px !important;
  }

  & .emoji-mart-anchors button {
    cursor: pointer;
  }

  & .emoji-mart-no-results {
    padding-top: 40px;
  }
`;
